import React from 'react';
import { Text, Colors } from '@tapresearch/ui/components';
import { Flex, Badge } from '@mantine/core';
export var CurrentUserLabel = function(param) {
    var user = param.user, constants = param.constants;
    var _user_organization_membership, _user_organization_membership1, _user_organization;
    var isAdmin = (user === null || user === void 0 ? void 0 : (_user_organization_membership = user.organization_membership) === null || _user_organization_membership === void 0 ? void 0 : _user_organization_membership.is_active) && (user === null || user === void 0 ? void 0 : (_user_organization_membership1 = user.organization_membership) === null || _user_organization_membership1 === void 0 ? void 0 : _user_organization_membership1.role) === constants.ORGANIZATION_ROLE_ADMIN;
    return /*#__PURE__*/ React.createElement(Flex, {
        direction: "column"
    }, isAdmin && /*#__PURE__*/ React.createElement(AdminBadge, null), /*#__PURE__*/ React.createElement(Text, {
        isTruncated: true,
        display: "block",
        maxW: "95%",
        fontWeight: "medium"
    }, user === null || user === void 0 ? void 0 : user.first_name, " ", user === null || user === void 0 ? void 0 : user.last_name), /*#__PURE__*/ React.createElement(Text, {
        isTruncated: true,
        display: "block",
        maxW: "95%",
        fontSize: "xs",
        fontWeight: "medium",
        color: "whiteAlpha.700",
        mt: 2
    }, user === null || user === void 0 ? void 0 : (_user_organization = user.organization) === null || _user_organization === void 0 ? void 0 : _user_organization.company_name));
};
var AdminBadge = function() {
    return /*#__PURE__*/ React.createElement(Badge, {
        bg: Colors.gradients.orangeFuschia,
        radius: "xs",
        variant: "filled",
        h: 16,
        px: 5,
        mt: 2,
        sx: {
            fontWeight: 500,
            textTransform: 'none',
            alignSelf: 'flex-start',
            position: 'relative',
            top: '-8px'
        }
    }, "Admin");
};
